
import { createFileListItem, isSafeFile, gaEvent, safeFilename, CreateDirectories, Utf8ArrayToStr   } from './Utils' 
import DropboxService from './DropboxService'

export default class _ZIPService {
    archiveFile = null;
    entries = null;
    fileList = new Set();
    unfilteredCount;
    filter;
    encrypted = false;
    extractor;
    dbxService;
    password;
    isMac = false;
    
    
    
    constructor(archiveFile, filter) {
        this.archiveFile = archiveFile;
        this.filter = filter;
        //console.log('Filter set to', this.filter);
    }

    getUnfilteredCount() {
        return this.unfilteredCount;
    }

    async setPassword(password) {
        this.password = password;
        return this.getFileList(true);
    }
    
    getExtractedFiles() {
        return window._extractor.extract({ files: () => true });
    }

    

    async getFileList(reset, isMacCompressed) {
        // https://gildas-lormeau.github.io/zip.js/core-api.html
        
        this.isMac = isMacCompressed;

        if (reset || this.fileList.size < 1) {
            const zip = window.zip; 
            
            let options = {useWebWorkers: true, password: this.password};
            const reader = new zip.ZipReader(new zip.BlobReader(this.archiveFile), options);
            this.entries = await reader.getEntries();
            //console.log(this.entries);
            this.fileList = new Set();
            let fileCount = 0;
            let directories = new Set();
            if (this.entries.length) {

                for (const entry of this.entries) {                    
                    //fileCount = fileCount + 1;
                    if (entry.encrypted) {
                        this.encrypted = true;
                    }                    
                    const directory = entry.filename.split("/").slice(0,-1).join("/");
                    
                    if(directory.indexOf('__MACOSX') > -1) { // Ignore these...
                        if(!isMacCompressed) {
                            throw 'Mac compressed';
                        }
                        continue;
                    }
                    
                    if (!directories.has(directory) && directory != '' ) {
                        // Check to make sure parent directories are there too
                        let counter = 0;
                        let parentParts = directory.split("/");
                        do {
                            counter++;
                            let parent = parentParts.slice(0,-counter).join("/");
                            if(!directories.has(parent) && parent != '') {
                                this.fileList.add(createFileListItem(parent, true, 0));fileCount++;
                                directories.add(parent);        
                            }
                        } while (parentParts.length >= counter);
                        
                        this.fileList.add(createFileListItem(directory, true, 0));fileCount++;
                        //console.log('Adding directory', directory);
                        directories.add(directory);
                    }
                    

                    if (isSafeFile(entry.filename)) {                    
                        const ext = entry.filename.split('.').pop();
                        if (!entry.directory) { // Already added directories above...
                            fileCount++; 
                            if(!this.filter || ext.indexOf(this.filter) > -1) {                        
                                let name = entry.filename;
                                //console.log('entry.filename', entry.filename);
                                
                                if (this.isMac) {
                                    
                                    name = Utf8ArrayToStr(entry.rawFilename);                                    
                                    //name = Utf8ArrayToStr([105, 109, 97, 204, 136, 103, 101, 45, 116, 119, 111, 204, 136, 46, 112, 110, 103]);
                                    //name = Utf8ArrayToStr([ 97, 204, 136]);
                                    
                                    //console.log('raw', entry.rawFilename);
                                    //console.log('converted name', name);
                                    
                                }
                                this.fileList.add(createFileListItem(name, entry.directory, entry.uncompressedSize));
                            }
                        }
                    }                
                }
                this.unfilteredCount = fileCount;                        
            }          
            // close the ZipReader
            await reader.close(); 
                                                  
        }        
        return this.fileList;
        
    }


    isEncrypted() {
        return this.encrypted;
    }

    async extractFile(filename) {           
        let file = this.entries.find(f => f.filename == filename);        
        if (!file) { // Might be mac compressed file....            
            file = this.entries.find(f => Utf8ArrayToStr(f.rawFilename) == filename);        
        }
                
        const fileData = await file.getData(new window.zip.BlobWriter());                
        return fileData;        
    }

    async saveAll(outputDir, progressUpdateFn) {
        if (outputDir === '') {
            console.log("No output directory selected, please select an output directory first");
            return;
        }

        let writer;
        let fileCounter = 0;
        //let totalFiles = this.fileList.size; // WARNING: This might not always be the total count!!!
        let totalFiles = this.unfilteredCount;
        let unallowedFiles = [];
        
        for (const file of this.entries) {
            let filename;
            if (this.isMac) {
                filename = Utf8ArrayToStr(file.rawFilename);
            } else {
                filename = file.filename;
            }

            const ext = filename.split('.').pop();
                
            if(file.filename.indexOf('__MACOSX') > -1) { // Ignore these...
                continue;
            }

            
            if (!file.directory && isSafeFile(filename) && (!this.filter || ext.indexOf(this.filter) > -1) ) { 
                
                const filePath = safeFilename(filename);
                
                const [dir, fileName] = await CreateDirectories(outputDir, filePath);
                let exists;  // eslint-disable-line
                    try {
                        'getFile' in dir ? await dir.getFile(fileName, {create: false}) : await dir.getFileHandle(fileName, {create: false});
                        exists = true;
                    } catch(e) {
                        // Continue.
                        exists = false;
                    }
                    try {
                        const outputFile = 'getFile' in dir ? await dir.getFile(fileName, {create: true}) : await dir.getFileHandle(fileName, {create: true});                
                        
                        progressUpdateFn({currentFile: filePath, progress: (fileCounter/totalFiles)*100 }); // TODO: Maybe check to see that this is a function?
                        writer = await outputFile.createWritable({keepExistingData: false}); 
                        // let blob = new Blob([file.extraction]);
                        let blob = await file.getData(new window.zip.BlobWriter()); // NOTE: THIS IS THE ONLY CODE SPECIFIC TO THIS IMPLEMENTATION!!!
                        
                        const stream = blob.stream();
                        await stream.pipeTo(writer);
                    } catch (ex) {                   
                        if(ex.message && ex.message.indexOf('Name is not allowed') > -1) {                    
                            console.log(ex);                    
                            unallowedFiles.push(createFileListItem(file.filename, false, file.uncompressedSize));
                            gaEvent('name-not-allowed-warning', filePath);
                        } else if(ex.message && ex.message.indexOf('Safe Browsing')) {
                            console.log(ex);                    
                            unallowedFiles.push(createFileListItem(file.filename, false, file.uncompressedSize));
                            gaEvent('name-not-allowed2-warning', filePath);
                        } else {
                            console.log('ex', filePath);
                            gaEvent('zipjs-save-all-error', filePath); 
                            throw ex;
                        }
                    }
                }
                fileCounter++;           
            }
            return {unallowedFiles};
    }
    async saveAllToDropbox(progressUpdateFn) {        
        if(!this.dbxService) {
            this.dbxService = new DropboxService();
        }
        let fileCounter = 0;
        let totalFiles = this.fileList.size; // WARNING: This might not always be the total count!!!
        
        for (const file of this.entries) {
            const ext = file.filename.split('.').pop();
            
            if(file.filename.indexOf('__MACOSX') > -1) { // Ignore these...
                continue;
            }

            if (!file.directory  && isSafeFile(file.filename) && (!this.filter || ext.indexOf(this.filter) > -1) ) {                        
                let blob = await file.getData(new window.zip.BlobWriter()); 
                const filePath = safeFilename(file.filename);
                progressUpdateFn({currentFile: filePath, progress: fileCounter === 0? 0 : (fileCounter/totalFiles)*100 });
                await this.dbxService.uploadFile(filePath, blob); 
            }
            fileCounter++;
        }
    }

    async saveFileToDropbox(fullpath) {        
        if(!this.dbxService) {
            this.dbxService = new DropboxService();
        }
        
        let blob = await this.extractFile(fullpath);
        // Individual files aren't saved with full path...        
        let name = safeFilename(fullpath.split('/').pop());        
        return this.dbxService.uploadFile(name, blob); 
    }

}